import { jsx as _jsx } from "react/jsx-runtime";
export function ArrowIcon({ ...rest }) {
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 12 12", ...rest, children: _jsx("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", d: "M1.333 6h9.334m0 0L6 1.333M10.667 6L6 10.667" }) }));
}
